/** @format */

import { isPlatformBrowser } from '@angular/common';
import {
	Directive,
	ElementRef,
	HostBinding,
	Inject,
	Input,
	OnInit,
	PLATFORM_ID
} from '@angular/core';
import { Environment } from '@shared/data-access/interfaces';

@Directive({
	standalone: true,
	selector: '[sharedUtilsDirectiveCommonLazyLoad]'
})
export class LazyLoadDirective implements OnInit {
	@HostBinding('attr.src') srcAttr;
	@HostBinding('class.loaded') chkLoaded = false;
	@HostBinding('class.redraw') redraw = false;
	@HostBinding('style.display') display: string;

	//eslint-disable-next-line @angular-eslint/no-input-rename
	@Input('sharedUtilsDirectiveCommonLazyLoad') imageToLoad: string;
	@Input() isVideo = false;
	@Input() willLazyLoad = true;

	defaultImage = 'transparent_pixel?$png$';
	loaded = false;
	modernSupport = false;

	constructor(
		private el: ElementRef,
		@Inject(PLATFORM_ID) protected platformId: any,
		private environment: Environment
	) {
		this.srcAttr = this.environment.thirdParty.images.scene7proxy.marketing + this.defaultImage;
		this.modernSupport = 'loading' in HTMLImageElement.prototype;
	}

	ngOnInit() {
		if (isPlatformBrowser(this.platformId)) {
			if (this.modernSupport) {
				this.el.nativeElement.setAttribute('loading', 'lazy');
				this.loadImage();
			} else if (this.canLazyLoad()) {
				this.lazyLoadImage();
			} else {
				this.loadImage();
			}
		}
	}

	private canLazyLoad() {
		return window && 'IntersectionObserver' in window && this.willLazyLoad;
	}

	/* istanbul ignore next */
	private lazyLoadImage() {
		const obs = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.intersectionRatio > 0) {
						setTimeout(() => {
							this.loadImage();
							obs.unobserve(this.el.nativeElement);
						}, 250);
					}
				});
			},
			{ threshold: [0.1, 0.3, 0.5, 0.7, 0.9] }
		);
		obs.observe(this.el.nativeElement);
	}

	private loadImage() {
		this.srcAttr = this.imageToLoad;
		this.chkLoaded = true;
		this.loaded = true;

		if (this.isVideo) {
			this.el.nativeElement.setAttribute('loop', true);
			this.el.nativeElement.setAttribute('autoplay', true);
		}
	}
}
